import React from 'react';
import Text from '../text';
import TrackPage from '../track-page';
import css from './screen-error.module.css';

function ScreenError({
  headline,
  instructions,
  errorName,
}: {
  headline?: string;
  instructions?: React.ReactNode;
  errorName?: string;
}): React.ReactElement {
  return (
    <div className="d-sm-flex flex-sm-column p-sm-24">
      <TrackPage category="error" name={errorName || 'not-found'} />
      <Text el="h1" type="title1-blinkui">
        {headline || 'Uh oh! We couldn’t find this page.'}
      </Text>
      {instructions || (
        <Text el="h2" type="body1-blinkui">
          Please return to{' '}
          <a href="/" className={css.link}>
            blinkhealth.com
          </a>
        </Text>
      )}
    </div>
  );
}

export default ScreenError;
